import React from 'react';

const ZebralearnBlackLogo = (
  props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>,
) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      viewBox='0 0 16 16'
      fill='none'
      {...props}
    >
      <g clipPath='url(#clip0_27647_45753)'>
        <path
          d='M1.62128 1.64825L3.11184 3.00271L5.07078 3.01063L6.07703 1.62109L1.62128 1.64825Z'
          fill='#3C3B3E'
        />
        <path
          d='M1.61963 1.64453V7.55571L3.1102 2.99899L1.61963 1.64453Z'
          fill='#282829'
        />
        <path
          d='M3.11026 3L5.06919 3.00792L1.61969 7.55672L3.11026 3Z'
          fill='black'
        />
        <path
          d='M7.38031 3.00268L8.57345 1.66406H12.0309L9.12045 3.0106L7.38031 3.00268Z'
          fill='#3C3B3E'
        />
        <path
          d='M7.38039 3L9.12052 3.00792L3.43176 9.86397L1.65173 9.88544L7.38039 3Z'
          fill='#504F53'
        />
        <path
          d='M1.65328 9.88475L3.43331 9.86328L1.63391 14.3329L1.65328 9.88475Z'
          fill='#282829'
        />
        <path
          d='M3.43331 9.86662L9.12208 3.0106L12.0325 1.66406L1.63391 14.3362L3.43331 9.86662Z'
          fill='black'
        />
        <path
          d='M3.98578 14.3079L6.97261 12.82L12.7081 6.00242L14.413 1.62109L3.98578 14.3079Z'
          fill='#3C3B3E'
        />
        <path
          d='M6.97261 12.8164L8.70249 12.9273L7.48315 14.2988L3.98578 14.3044L6.97261 12.8164Z'
          fill='#282829'
        />
        <path
          d='M14.412 1.62109L12.7072 6.00242H14.4382L14.412 1.62109Z'
          fill='#282829'
        />
        <path
          d='M12.7069 6H14.4379L8.70125 12.9284L6.97137 12.8176L12.7069 6Z'
          fill='black'
        />
        <path
          d='M11.0267 12.8925H12.9037L14.3908 8.42188L11.0267 12.8925Z'
          fill='#3C3B3E'
        />
        <path
          d='M11.0264 12.8906H12.9032L14.4177 14.3322L9.95172 14.3265L11.0264 12.8906Z'
          fill='#282829'
        />
        <path
          d='M14.3906 8.42188L14.4179 14.3342L12.9034 12.8925L14.3906 8.42188Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_27647_45753'>
          <rect
            width='12.8'
            height='12.8'
            fill='white'
            transform='translate(1.59998 1.60156)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default ZebralearnBlackLogo;
